import { ReactNode } from 'react';

import { Box, Typography } from '@material-ui/core';

import { AppRoundedRadio } from '../inputs';
import { useStyles } from './styles';

interface Props {
  label: string;
  /** One line under the label saying what picking this option means in practice. */
  hint?: string;
  selected: boolean;
  onSelect: () => void;
  /** Extra controls revealed under the label while this option is the selected one. */
  children?: ReactNode;
}

export const SettingsOptionRow = ({ label, hint, selected, onSelect, children }: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.option}>
      <Box className={classes.optionRow} onClick={onSelect}>
        <Box className={classes.optionText}>
          <Typography className={classes.optionLabel}>{label}</Typography>

          {!!hint && <Typography className={classes.optionHint}>{hint}</Typography>}
        </Box>

        <AppRoundedRadio checked={selected} />
      </Box>

      {selected && !!children && <Box className={classes.optionDetails}>{children}</Box>}
    </Box>
  );
};

/** Groups option rows so the dividers between them are unaffected by the card body gap. */
export const SettingsOptionList = ({ children }: { children: ReactNode }) => {
  const classes = useStyles();

  return <Box className={classes.optionList}>{children}</Box>;
};
